import { useEffect, useState } from 'react'
import { company, CustomerApplication } from '../../../utilities/CustomerData'
import TagManager from 'react-gtm-module'

export function ApplicationStep1e({ _customerApplication, gclid, step, setStep, handleSubmitApplication }) {
  const customerApplication = new CustomerApplication(_customerApplication)
  const [loading, setLoading] = useState(true)
  const [preQualified, setPreQualified] = useState(false)

  useEffect(() => {
    if((customerApplication.isSelfEmployed === 'Yes' || customerApplication.isSmallOwner === 'Yes') && customerApplication.hadFamilyMember === 'Yes') {
      setPreQualified(true)
      setLoading(false)

      if(company.companyId === '1d622c43-baf3-45b6-8225-ec055b0e39f6') {
        TagManager.dataLayer({
          dataLayer: {
            event: 'prequalification',
            gclid: gclid ?? ''
          }
        }) 
      }
    } else {
      setPreQualified(false)
      setLoading(false)
      handleSubmitApplication('Not Qualified')
    }
  }, [])

  return  (
    <div className='w-full h-full flex flex-col items-center lg:justify-center mt-10 max-sm:mt-5 overflow-y-auto'>
      {loading ? (
        <div className='flex flex-row items-center justify-center gap-2'>
          <div className='loader ease-linear rounded-full border-[6px] border-t-[6px]  h-8 w-8 mt-4 mb-4'></div>
          <p>Loading...</p>
        </div>
      ) : (
        preQualified ? (
          <div className='w-full h-full flex flex-col items-center justify-center px-4 py-6 gap-4 mt-10'>
            <p className='lg:text-5xl text-4xl font-bold text-setcg'>Congratulations!</p>
            <p className='lg:text-2xl text-xl font-bold'>You have pre-qualified</p>
            <p className='lg:text-lg'>You may be eligible for a tax credit up to</p>
            <p className='lg:text-4xl text-3xl font-bold text-red-600'>$32,220</p>
            <p className='lg:text-lg'>based on your answers</p>
            <button
              onClick={() => setStep(step + 1)}
              className='px-6 py-3 bg-primaryColor hover:bg-primaryDarkColor transition duration-200 text-white rounded-md'>
              Continue Application
            </button>
            <iframe
              src='https://setcpros.com/pre-qualified-conversion-page/'
              style={{ width: 0, height: 0 }}
              title='Tracker'
            />
          </div>
        ) : (
          <div className='w-full h-full flex flex-col items-center justify-center px-4 py-6 gap-4 mt-10'>
            <p className='lg:text-5xl text-4xl font-bold text-red-700'>Sorry.</p>
            <p className='lg:text-2xl text-xl font-bold'>Based on your answers, you do not qualify for the Self Employed Tax Refund Credit.</p>
          </div>
        )
      )}
    </div>
  )
}